
import { useEffect } from "react";

const ChromeExtensionUninstall = () => {
  useEffect(() => {
    window.location.href = "https://chromewebstore.google.com/detail/chat-gpt-for-chrome-with/fnmihdojmnkclgjpcoonokmkhjpjechg";
  }, []);

  return (
    <div className="container mx-auto px-4 py-16 min-h-screen">
      <h1 className="text-3xl font-bold text-center mt-20">
        Redirecting...
      </h1>
    </div>
  );
};

export default ChromeExtensionUninstall;
